const POINTS_TO_POUNDS_RATE = 0.005; // 1 point = £0.005

/**
 * Calculate the monetary value of points
 * Every 1000 points = £5 (0.005 per point)
 * @param points - Number of points
 * @returns Monetary value in pounds
 */
const getPointsValue = (points: number): number => {
  return points * POINTS_TO_POUNDS_RATE;
};

/**
 * Calculate the number of points from a monetary value
 * Every £1 = 200 points (since £1 / 0.005 = 200)
 * @param value - Monetary value in pounds
 * @returns Number of points
 */
const getPointsFromValue = (value: number): number => {
  return value / POINTS_TO_POUNDS_RATE;
};

export default getPointsValue;

export { getPointsFromValue, getPointsValue };
